webpackJsonp([1],{

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(48)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(49),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Timer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Timer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Timer_vue__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#main',
  methods: {
    sendForm: function sendForm() {
      var toggleEvent = null;
      var form = this.$el.getElementsByTagName('form')[0];
      try {
        toggleEvent = new Event('submit');
      } catch (error) {
        toggleEvent = document.createEvent('Event');
        toggleEvent.initEvent('submit', true, true);
      }
      // 子コンポーネントのapplyメソッドからイベントが発火される
      form.dispatchEvent(toggleEvent);
    }
  },
  components: {
    Timer: __WEBPACK_IMPORTED_MODULE_2__components_Timer_vue___default.a
  }
});

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timer',
  props: {
    'second': Number
  },
  data: function data() {
    var timestamp = Date.now();
    return {
      timeLimit: this.second,
      endTimestamp: timestamp + this.second * 1000,
      timer: setInterval(this.repeat, 100),
      canvasStyle: {
        animationDuration: this.second + 's',
        animationPlayState: 'running'
      },
      running: true
    };
  },

  methods: {
    repeat: function repeat() {
      if (this.running) {
        var limit = this.endTimestamp - Date.now();
        if (limit > 0) {
          this.timeLimit = parseInt(limit * 0.001);
        } else {
          this.timeLimit = 0;
          this.stop();
        }
      } else {
        this.stop();
      }
    },
    stop: function stop() {
      clearInterval(this.timer);
      this.canvasStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.canvasStyle, { animationPlayState: 'paused' });
      this.running = false;
      this.$emit('send-parent-form');
    }
  }
});

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "timer"
    }
  }, [_c('div', {
    staticClass: "layer_canvas",
    style: (_vm.canvasStyle)
  }, [_c('span', {
    staticClass: "timeText"
  }, [_vm._v(_vm._s(_vm.timeLimit))])])])
},staticRenderFns: []}

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[14]);


// WEBPACK FOOTER //
// static/js/app.js